import { render } from "./AtomSubTitle.vue?vue&type=template&id=6862d346&scoped=true&ts=true"
import script from "./AtomSubTitle.vue?vue&type=script&lang=ts&setup=true"
export * from "./AtomSubTitle.vue?vue&type=script&lang=ts&setup=true"

import "./AtomSubTitle.vue?vue&type=style&index=0&id=6862d346&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6862d346"],['__file',"src/components/atoms/AtomSubTitle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6862d346"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6862d346', __exports__)) {
    api.reload('6862d346', __exports__)
  }
  
  module.hot.accept("./AtomSubTitle.vue?vue&type=template&id=6862d346&scoped=true&ts=true", () => {
    api.rerender('6862d346', render)
  })

}


export default __exports__